module.exports = __webpack_public_path__ + "images/5c75a8c11a739f0c87285afc79f0de3a-logo_alpha.png";